<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();
  export let title = 'Pricing Plans';

  const onPlanSelect = (name) => {
    dispatch('select', {
      plan: name.toLowerCase()
    });
  }

  let pricingPlans = [
    {
      title: 'free',
      cost: 0,
      callback: null,
      features: [
        '50 items to list',
        '100Mb of storage',
        '1 user',
        'Ad supported',
        '1 office location',
        ''
      ]
    },
    {
      title: 'Basic',
      cost: 99,
      callback: null,
      features: [
        '500 items/yr to list',
        '1Gb of storage',
        '3 users',
        'No ads',
        '2 office locations',
        'Branding at $1000/yr'
      ]
    },
    {
      title: 'Pro',
      cost: 1299,
      callback: null,
      features: [
        '10000 items/yr to list',
        '10Gb of storage',
        '5 users',
        'No ads',
        '3 office locations',
        'Branding at $2000/yr'
      ]
    },
    {
      title: 'Enterprise',
      cost: 'CONTACT<br>US',
      callback: null,
      features: [
        'Unlimited items to list',
        '100Gb of storage',
        'Unlimited users',
        'No ads',
        '5 office locations<br>Additional locations at $50/yr',
        'Branding at $5000/yr'
      ]
    },
  ];
</script>

<style>
  * {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
  }

  #pricing-plans .row {
    align-items: flex-start;
    flex-wrap: wrap;
    --border-radius: 5px;
  }

  #pricing-plans .row .price-plan-bucket {
    margin-right: 1vw;
    margin-bottom: 1vw;
    min-width: 386px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  #pricing-plans .row .price-plan-bucket:last-child {
    margin-right: 0;
  }

  #pricing-plans .row .price-plan-bucket header {
    text-transform: uppercase;
    background-color: var(--secondary);
    color: var(--secondary-text);
    height: 64px;
    text-align: center;
    font-size: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--border-radius) var(--border-radius) 0 0;
  }

  #pricing-plans .row .price-plan-bucket .price-plan-bucket-content {
    border: 1px solid black;
    border-top: none;
    border-radius: 0 0 var(--border-radius) var(--border-radius);
    flex: 1;
  }

  #pricing-plans .row .price-plan-bucket .price-plan-bucket-content .cost-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 264px;
    color: var(--secondary);
    font-size: 64px;
  }

  #pricing-plans .row .price-plan-bucket .price-plan-bucket-content .cost-section .cost-text {
    margin-bottom: 48px;
  }

  #pricing-plans .row .price-plan-bucket .price-plan-bucket-content .cost-section sup {
    font-size: 44px;
  }

  #pricing-plans .row .price-plan-bucket .price-plan-bucket-content .cost-section sub {
    font-size: 20px;
  }

  #pricing-plans .row .price-plan-bucket .price-plan-bucket-content .cost-section button {
    font-size: 20px;
    padding: 14px 36px;
  }

  #pricing-plans .row .price-plan-bucket .price-plan-bucket-content .features {
    height: 490px;
  }

  #pricing-plans .row .price-plan-bucket .price-plan-bucket-content .features > div {
    min-height: 64px;
    font-size: 14pt;
    padding: 20px 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  #pricing-plans .row .price-plan-bucket .price-plan-bucket-content .features > div:nth-child(odd) {
    background-color: var(--panel);
  }

  /* Small devices (landscape phones, 767px and up) */
  @media (max-width: 767px) {
    #pricing-plans .row .price-plan-bucket {
      min-width: auto;
      width: 94%;
      margin-right: 0;
      margin-bottom: 6vw;
    }

    #pricing-plans .row .price-plan-bucket .price-plan-bucket-content .cost-section .cost-text {
      font-size: 36px;
      text-transform: uppercase;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) {

  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) {

  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    #pricing-plans .row .price-plan-bucket:nth-child(3) {
      margin-right: 0;
    }
  }

  /* Super large devices (large desktops, 1400px and up) */
  @media (min-width: 1400px) {
    #pricing-plans .row .price-plan-bucket:nth-child(3) {
      margin-right: 1vw;
    }

    #pricing-plans .row .price-plan-bucket:last-child {
      margin-right: 0;
    }
  }
</style>

<main id="pricing-plans" class="section">
  <h1 class="title">{title}</h1>
  <div class="row row-centered">
    {#each pricingPlans as plan, i}
    <div class="price-plan-bucket">
      <header>{plan.title}</header>
      <div class="price-plan-bucket-content">
        <div class="cost-section">
          <div class="cost-text">
            {#if i < pricingPlans.length - 1}
              <sup>$</sup>{plan.cost}<sub>/month</sub>
            {:else}
              Contact Us
            {/if}
          </div>
          <button on:click={() => onPlanSelect(plan.title)}>Contact Us</button>
        </div>
        <div class="features">
          {#each plan.features as feature}
          <div>{@html feature}</div>            
          {/each}
        </div>
      </div>
    </div>
    {/each}
  </div>
</main>